import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

export const useEngagementTab = () => {
  const { commentsEnabled, reactionsDisabled } = storeToRefs(useViewerItemStore());

  const engagementTabName = computed(() => {
    if (commentsEnabled.value && !reactionsDisabled.value) {
      return 'Comments & Reactions';
    }
    if (commentsEnabled.value) {
      return 'Comments';
    }
    return 'Reactions';
  });

  const engagementTabVisible = computed(() => commentsEnabled.value || !reactionsDisabled.value);

  return { engagementTabName, engagementTabVisible };
};
